import { Directive, Input } from '@angular/core';
import { NG_VALIDATORS, Validator, AbstractControl, ValidationErrors } from '@angular/forms';

@Directive({
  selector: '[appGstNumber]',
  providers: [
    {
      provide: NG_VALIDATORS,
      useExisting: GstNumberDirective,
      multi: true
    }
  ]
})
export class GstNumberDirective implements Validator {
  validate(control: AbstractControl): ValidationErrors | null {
    const gstPattern = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}[Z]{1}[0-9A-Z]{1}$/;

    if (control.value && !gstPattern.test(control.value)) {
      return { invalidGSTNumber: true };
    }

    return null;
  }
}
